"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.structuralConfigKeys = structuralConfigKeys;
exports.hasStructuralConfig = hasStructuralConfig;
/**
 * Configuration keys whose change reshapes the graph: the routes of a branch
 * own edges, the fields of a JSON extract step own output slots that later
 * steps bind to. The builder writes every other field value straight into the
 * workflow document; these keys go through the server command, which derives
 * edges and slots in one place for the builder and the AI tools alike.
 */
const control_flow_1 = require("./control-flow");
const BRANCH_KEYS = ['ports', 'defaultPortId'];
const JSON_EXTRACT_KEYS = ['fields', 'includeRest', 'restOutputName'];
/** The step type without the engine prefix (`swr.branch_xor` → `branch_xor`). */
function bareStepType(stepType) {
    const lower = stepType.toLowerCase();
    return lower.startsWith('swr.') ? lower.slice('swr.'.length) : lower;
}
/** The structural configuration keys of a step type; empty when it has none. */
function structuralConfigKeys(stepType) {
    const bare = bareStepType(stepType);
    if (control_flow_1.CONTROL_BRANCH_TYPES.has(bare))
        return BRANCH_KEYS;
    if (bare === 'json_extract')
        return JSON_EXTRACT_KEYS;
    return [];
}
/** Whether a step type has configuration keys that reshape the graph. */
function hasStructuralConfig(stepType) {
    return structuralConfigKeys(stepType).length > 0;
}
